// extracted by mini-css-extract-plugin
export default {"container":"DietProgramSummary_container__y65z4","isDesktop":"DietProgramSummary_isDesktop__tQs9i","appBtnWrap":"DietProgramSummary_appBtnWrap__QopR-"};